import React from "react";
import SuperUserHomePageUI from "../../../templates/SuperUserHomePageUI";
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from "../../../components/common/SpinnerComponentUI";
import CardUI from "../../../widgets/layout/CardUI";

const VehicleTypeCountPageUI = ({ context, errorList, vehicleTypeSummary, vehicleTypeDetails, onRefreshClick, response }) =>
    <SuperUserHomePageUI context={context} className='pg_su_vt' topnav='accounts'
        headerText='Vehicle Type Report' centered={!response || !errorList} dimension='w768' page='vehicles'
    >
        {
            (!response || !errorList) &&
            <SpinnerComponentUI />
        }
        {
            response &&
            <LRTableActionsUI location='top'
                left={
                    <span className='g_flex_left g_flex_h'>
                        <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />

                        <span className='g_m_left_100 g_large'><b>Vehicle Type Report</b></span>
                    </span>
                }
                right={<span />}
            />
        }
        {
            response && vehicleTypeSummary && vehicleTypeDetails &&
            <>
                <VehicleTypeSummaryUI loanVehicleTypeTotalList={vehicleTypeSummary} context={context} response={response} />
                <VehicleTypeDetailsUI loanVehicleTypeList={vehicleTypeDetails} context={context} />
            </>
        }
    </SuperUserHomePageUI>

const VehicleTypeSummaryUI = ({ loanVehicleTypeTotalList, response }) => (
    <CardUI title='Vehicle Type Summary' >
        <table >
            <tbody>
                {loanVehicleTypeTotalList.map((item, i) => (
                    <tr key={i}>
                        <td>{item.vehicleTypeName}</td>
                        <th className='g_p_left_100 g_text_right' >{item.vehicleCount}</th>
                    </tr>
                ))}
                <tr>
                    <th className='g_p_left_100'>Total</th>
                    <th className='g_p_left_100 g_text_right' >{response.totalCount}</th>
                </tr>
            </tbody>
        </table>
    </CardUI>
);

const VehicleTypeDetailsUI = ({ loanVehicleTypeList }) => (
    <CardUI title='Vehicle Type Details' className='g_m_top_100'>
        <table>
            <tbody>
                <tr>
                    <th >Account Name</th>
                    <th className='g_p_left_100'>Loan Name</th>
                    <th className='g_p_left_100'>Vehicle Type</th>
                    <th className='g_p_left_100'>Vehicle Count</th>
                </tr>
                {loanVehicleTypeList.map((item, i) => (
                    <tr key={i}>
                        <td >{item.accountName}</td>
                        <td className='g_p_left_100'>{item.loanName}</td>
                        <td className='g_p_left_100'>{item.vehicleTypeName}</td>
                        <td className='g_text_right g_p_left_100' >{item.vehicleCount}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </CardUI>
);


export default VehicleTypeCountPageUI;